<i18n>
{
  "fr": {
    "configuratorEditorThemePickerButton": {
      "useCustomTheme": "Choisir parmi nos 750+ modèles à personnaliser",
      "replaceCustomTheme": "Changer mon visuel"
    }
  }
}
</i18n>
<template>
  <button
    :class="`${BLOCK_SELECTOR} ${BLOCK_SELECTOR}--${themeType}`"
    type="button"
    @click="$emit('request-open-theme-picker-modal')"
  >
    <template v-if="themeType === ThemeType.CUSTOM">
      <img
        :class="`${BLOCK_SELECTOR}__use-custom-theme-button-image`"
        :src="ThemePickerImage"
        alt="Theme picker illustration"
      />
      <span>{{
        $t('configuratorEditorThemePickerButton.useCustomTheme')
      }}</span>
    </template>
    <template v-else-if="themeType === ThemeType.GENERIC">
      <img
        :class="`${BLOCK_SELECTOR}__use-custom-theme-button-image ${BLOCK_SELECTOR}__use-custom-theme-button-image--generic`"
        :src="
          activeConfiguration && activeConfiguration.image
            ? activeConfiguration.image
            : activeProduct.image
        "
        :alt="`${activeProduct.name} example`"
      />
      <span :class="`${BLOCK_SELECTOR}__use-custom-theme-button-text`">{{
        $t('configuratorEditorThemePickerButton.replaceCustomTheme')
      }}</span>
      <span :class="`${BLOCK_SELECTOR}__use-custom-theme-button-icon`"></span>
    </template>
  </button>
</template>

<script>
import { ThemeType } from '../../api/static/ThemeType';
import {
  mapState,
  mapGetters as mapConfiguratorGetters,
  ConfiguratorGetters,
} from '../../store/modules/configurator';
import ThemePickerImage from '@/images/configurator/pick-theme.webp';

export default {
  name: 'ConfiguratorEditorThemePickerButton',
  emits: ['request-open-theme-picker-modal'],
  props: {},
  data() {
    return {
      BLOCK_SELECTOR: 'configurator-editor-theme-picker-button',
      ThemePickerImage,
      ThemeType,
    };
  },
  computed: {
    ...mapConfiguratorGetters({
      activeProduct: ConfiguratorGetters.GET_ACTIVE_PRODUCT,
      activeConfiguration: ConfiguratorGetters.GET_ACTIVE_CONFIGURATION,
    }),
    ...mapState({
      themeType: 'themeType',
    }),
  },
};
</script>

<style lang="scss" scoped>
.configurator-editor-theme-picker-button {
  $block-selector: &;

  width: 100%;
  height: 6.5rem;
  color: $color-arapawa;
  border: 1px solid $color-arapawa;
  padding: 0.25rem;
  border-radius: 0.75rem;
  display: flex;
  background-color: $color-white;
  cursor: pointer;

  &--custom {
    align-items: center;
    flex-direction: column;
  }

  &--generic {
    flex-direction: row;
    border: 2px solid $color-red-razzmatazz;
    background-color: color.adjust($color-red-amaranth, $lightness: 90%);
    align-items: center;
    padding: 1.25rem;
    gap: 1.25rem;
  }

  &:hover {
    background-color: color.adjust($color-red-amaranth, $lightness: 90%);
  }

  &__use-custom-theme-button-image {
    min-height: 0;
    object-fit: contain;

    &--generic {
      height: 4.3125rem;
    }
  }

  &__use-custom-theme-button-text {
    flex: 1;
  }

  &__use-custom-theme-button-icon {
    &::after {
      @extend %icon;
      @extend %icon--replay;

      color: $color-arapawa;
      font-size: 0.875rem;
    }
  }
}
</style>
